import './confirm.css';
import i18n from '../../../i18n';

export const confirm = {
    open (options) {
      options = Object.assign({}, {
        title: '',
        message: '',
        onConfirm: function () {},
        onCancel: function () {}
      }, options);

      const closeLabel = i18n.t('approvals.close');
      const confirmLabel = i18n.t('approvals.confirm');
      const cancelLabel = i18n.t('approvals.cancel');

      const html = `
        <div class="confirm"> 
          <div class="confirm-container">
            <div class="confirm-titlebar">
              <span class="confirm-title">${options.title}</span>
              <button class="confirm-close" type="button" aria-label="${closeLabel}">
                &times;
              </button>
            </div>
            <div class="confirm-content">
              ${options.message}
            </div>
            <div class="confirm-buttons">
              <button class="confirm-button confirm-button-confirm confirm-button-fill" type="button">
                ${confirmLabel}
              </button>
              <button class="confirm-button confirm-button-cancel" type="button">
                ${cancelLabel}
              </button>
            </div>
          </div>
        </div>
      `;

      const template = document.createElement('template');
      
      // properly set the template HTML
      template.innerHTML = html;

      // Elements
      const confirmEl = template.content.querySelector('.confirm');
      const btnClose = template.content.querySelector('.confirm-close');
      const btnConfirm = template.content.querySelector('.confirm-button-confirm');
      const btnCancel = template.content.querySelector('.confirm-button-cancel');

      // Ensure elements exist before attaching listeners
      if (!confirmEl) {
        console.error('Confirm: failed to create dialog element');
        return;
      }

      confirmEl.addEventListener('click', e => {
        if (e.target === confirmEl) {
          options.onCancel();
          this._close(confirmEl);
        }
      });

      if (btnConfirm) {
        btnConfirm.addEventListener('click', () => {
          options.onConfirm();
          this._close(confirmEl);
        });
      }

      [btnCancel, btnClose].forEach(el => {
        if (!el) return;
        el.addEventListener('click', () => {
          options.onCancel();
          this._close(confirmEl);
        });
      });

      // Accessibility: set dialog role/attributes and focus
      const dialogContainer = template.content.querySelector('.confirm-container');
      if (dialogContainer) {
        dialogContainer.setAttribute('role', 'dialog');
        dialogContainer.setAttribute('aria-modal', 'true');
        dialogContainer.setAttribute('tabindex', '-1');
      }

      document.body.appendChild(template.content);

      // Ensure the modal is on top (some stacking contexts may still conflict)
      try {
        confirmEl.style.zIndex = '2147483647';
      } catch (e) {}

      // Prevent background scrolling while modal is open
      document.body.classList.add('confirm-open');

      // Focus the dialog container once it's in the DOM
      if (dialogContainer) {
        dialogContainer.focus();
      }

      // ESC key closes the dialog
      const escHandler = (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          options.onCancel();
          this._close(confirmEl);
        }
      };
      confirmEl._escHandler = escHandler;
      document.addEventListener('keydown', escHandler);
    },
    _close (confirmEl) {
      // Cleanup ESC handler
      if (confirmEl && confirmEl._escHandler) {
        document.removeEventListener('keydown', confirmEl._escHandler);
        delete confirmEl._escHandler;
      }

      // Restore background scrolling
      document.body.classList.remove('confirm-open');
      document.body.removeChild(confirmEl);
    }
};